import debug from 'debug';
import GoogleAnalytics from 'Minetilbud/Shared/Components/GoogleAnalyticsEvents/DataLayer';
import MatomoTagManager from 'Minetilbud/Shared/Components/matomo/tag-manager';
import PopoverService from 'Minetilbud/Shared/Components/PopoverService/PopoverService';
import Templates from '../templates/result-templates';

const log = debug('Search:Render:LinksPopover');
const googleAnalytics = new GoogleAnalytics();
const matomo = new MatomoTagManager();
const templates = new Templates();

class LinksPopover {
	/**
	 * @param {Object} options
	 * @param {string} options.customerName
	 * @param {Object} options.links
	 * @param {Event} options.linksEvent
	 */
	constructor({ customerName, links, linksEvent }) {
		this.customerName = customerName;
		this.links = links;
		this.linksEvent = linksEvent;

		this.clickedEvent = this.clickHandler.bind(this);
		this.removedEvent = this.removedHandler.bind(this);

		this.initialize();
	}

	/**
	 * @param {CustomEvent} event
	 */
	clickHandler(event) {
		const link = event.detail.target.closest('[data-js="product-links__link"]');

		if (link) {
			this.popover.Remove();
		}
	}

	eventListeners() {
		googleAnalytics.WatchStart(this.popover.Get());
		matomo.watchStart(this.popover.Get());
		document.addEventListener('popover-service-clicked', this.clickedEvent, false);
		document.addEventListener('popover-service-removed', this.removedEvent, false);
	}

	async initialize() {
		if (this.popover !== undefined && this.popover !== null && this.popover.IsVisible()) return;

		const dictionary = await templates.initDictionary();
		this.show();
		this.eventListeners();
	}

	/**
	 * @returns {string} markup for popover
	 */
	options() {
		const markup = this.links.map(link => templates.popoverOption({ customerName: this.customerName, title: link.title, url: link.url }));
		return markup.join('');
	}

	removedHandler() {
		googleAnalytics.WatchEnd(this.popover.Get());
		matomo.watchEnd(this.popover.Get());
		this.popover.EventsRemove();
		this.popover = null;
		document.removeEventListener('popover-service-clicked', this.clickedEvent, false);
		document.removeEventListener('popover-service-removed', this.removedEvent, false);
	}

	show() {
		this.popover = new PopoverService({
			headline: templates.getDictionaryText('goToShop'),
			template: this.options(),
			primaryColor: '#33f',
			secondaryColor: 'black',
			headerTextColor: 'white',
			pointerX: this.linksEvent.clientX,
			pointerY: this.linksEvent.clientY,
			event: this.linksEvent
		});
	}
}

export default LinksPopover;
